export default __webpack_public_path__ + "static/media/convertDarkMode.eeae2362.svg";